var exports = {
  "k": "xa15a2ab7--0f9fe6--container",
  "A": "xa15a2ab7--0f9fe6--item",
};

module.exports = exports;
